<!-- 从老金服迁移过来 -->
<template>
  <div class="wrap">
    <div class="paymentSuccess">
      <div class="left">
        <div class="c1">
          <i style="font-size: 48px" class="iconfont iconsuccess"></i
          >{{ payStatus ? '支付成功!' : '' }}
        </div>
        <div class="c2">¥ {{ order.totalAmount }}</div>
        <div v-if="memCoupon" class="c2">
          <p>
            恭喜获得一张<i>{{ memCoupon.amount }}元</i>的代金券
          </p>
          <p>
            请在<a href="/mem/user/coupon/queryUserCoupon.htm">我的优惠券</a
            >中查看
          </p>
        </div>

        <div class="c3">
          <el-button
            @click="
              () =>
                $router.push({
                  path: '/orderDetail',
                  query: { order: order.orderId },
                })
            "
            >查看订单详情</el-button
          >
          <p style="color: #999; margin-top: 20px">
            当日12点前成功签订承诺书的订单，次日18点前出函，当日12点后成功签订承诺书的订单，第三天18点前出函（如遇节假日顺延）。
          </p>
        </div>
      </div>
      <div class="line">
        <div class="block2"></div>
        <div class="block"></div>
        <div class="block3"></div>
      </div>
      <div class="right">
        <div class="c4"><em>订单编号：</em>{{ order.orderCode }}</div>
        <template v-if="order.applyType == '1000'">
          <div class="c4"><em>服务名称：</em>投标培训</div>
          <div class="c4"><em>课程主题：</em>{{ order.attr1 }}</div>
          <div class="c4 b30">
            <em>时间地点：</em>{{ order.attr2 }} {{ order.attr3 }}
          </div>
        </template>
        <template v-else-if="order.applyType == '2000'">
          <div class="c4"><em>服务名称：</em>商机订阅</div>
          <div class="c4"><em>主营行业：</em>{{ order.attr1 }}</div>
          <div class="c4"><em>业务地区：</em>{{ order.attr2 }}</div>
          <div class="c4 b30"><em>服务套餐：</em>{{ order.attr3 }}</div>
          <div class="c6">
            <em>接收订阅方式：</em>手机：{{ order.linkTel }}<br />邮箱：{{
              order.linkEmail ? order.linkEmail : '未设置'
            }}
          </div>
        </template>
        <template v-else-if="order.applyType == '3000'">
          <div class="c4"><em>服务名称：</em>会员专区</div>
          <div class="c4"><em>会员级别：</em>{{ order.attr1 }}</div>
          <div class="c4"><em>服务时长：</em>{{ order.attr2 }}</div>
          <div class="c4"><em>C A 时长：</em>{{ order.attr3 }}</div>
        </template>
        <template v-else-if="order.applyType == '4000'">
          <div class="c4 b30" id="courseNameTop">
            <em>服务名称：</em>投标学苑
          </div>
        </template>
        <template v-else-if="order.applyType == '5000'">
          <div class="c4 b30" id="expoundNameTop">
            <em>服务名称：</em>在线课程
          </div>
        </template>
        <template v-else-if="order.applyType == '7000'">
          <div class="c4"><em>服务名称：</em>电子保险保函</div>
          <div class="c4">
            <em>投 保 人：</em>{{ bfeViewOrderInfoExt.bidderCompanyName }}
          </div>
          <div class="c4">
            <em>被 保 人：</em>{{ bfeViewOrderInfoExt.tenderCompanyName }}
          </div>
          <div class="c4">
            <em>项目名称：</em>{{ bfeViewOrderInfoExt.projectName }}
          </div>
          <div class="c4">
            <em>开标时间：</em>{{ bfeViewOrderInfoExt.guaranteeStartDate }}
          </div>
          <div class="c4">
            <em>投标有效期(天)：</em>{{ bfeViewOrderInfoExt.validityPeriod }}
          </div>
          <div class="c4">
            <em>保险额度(万元)：</em>¥
            {{
              bfeViewOrderInfoExt.guaranteeAmount
                ? Number(bfeViewOrderInfoExt.guaranteeAmount)
                : 0
            }}
          </div>
        </template>
        <template v-else-if="order.applyType == '8000'">
          <div class="c4"><em>服务名称：</em>银行保函</div>
          <div class="c4">
            <em>投 标 人：</em>{{ bfeViewOrderInfoExt.bidderCompanyName }}
          </div>
          <div class="c4">
            <em>受 益 人：</em>{{ bfeViewOrderInfoExt.tenderCompanyName }}
          </div>
          <div class="c4">
            <em>项目名称：</em>{{ bfeViewOrderInfoExt.projectName }}
          </div>
          <div class="c4">
            <em>投标有效期(天)：</em>{{ bfeViewOrderInfoExt.validityPeriod }}
          </div>
          <div class="c4">
            <em>投标保证金金额(万元)：</em>¥
            {{
              bfeViewOrderInfoExt.guaranteeAmount
                ? Number(bfeViewOrderInfoExt.guaranteeAmount)
                : 0
            }}
          </div>
        </template>
        <template v-else-if="order.applyType == '9500'">
          <div class="c4"><em>服务名称：</em>增值客服</div>
          <div class="c4">
            <em>增值客服类型：</em>{{ bksServiceMainInfoExt.attr1 }}
          </div>
          <div class="c4">
            <em>联系人姓名：</em>{{ bksServiceMainInfoExt.linkMan }}
          </div>
          <div class="c4">
            <em>联系人手机：</em>{{ bksServiceMainInfoExt.linkMobile }}
          </div>
          <div class="c4">
            <em>联系人单位：</em>{{ bksServiceMainInfoExt.linkCompanyName }}
          </div>
          <div class="c4">
            <em>拟咨询事项说明：</em>{{ bksServiceMainInfoExt.remark }}
          </div>
        </template>
        <template v-else-if="order.applyType == '9600'">
          <div class="c4"><em>服务名称：</em>电子担保保函</div>
          <div class="c4">
            <em>投 标 人：</em>{{ bfeViewOrderInfoExt.bidderCompanyName }}
          </div>
          <div class="c4">
            <em>受 益 人：</em>{{ bfeViewOrderInfoExt.tenderCompanyName }}
          </div>
          <div class="c4">
            <em>项目名称：</em>{{ bfeViewOrderInfoExt.projectName }}
          </div>
          <div class="c4">
            <em>投标有效期(天)：</em>{{ bfeViewOrderInfoExt.validityPeriod }}
          </div>
          <div class="c4">
            <em>投标保证金金额(万元)：</em>¥
            {{
              bfeViewOrderInfoExt.guaranteeAmount
                ? Number(bfeViewOrderInfoExt.guaranteeAmount)
                : 0
            }}
          </div>
        </template>

        <template v-if="order.invoiceStatus != '1000' && invoice">
          <div class="c4">
            <em>发票信息：</em
            ><span
              >{{
                invoice.invoiceType == '10'
                  ? '增值税普通发票'
                  : invoice.invoiceType == '20'
                  ? '增值税专用发票'
                  : invoice.invoiceType == '30'
                  ? '增值税电子普通发票'
                  : ''
              }} </span
            >{{ invoice.invoiceTitle }}
          </div>
        </template>
        <template
          v-else-if="
            order.invoiceMethod == '30' && order.invoiceStatus == '1000'
          "
        >
          <div class="c4">
            <em>发票信息：</em>稍后填写
            <span style="color: #999"
              >（稍后在<a href="/mem/order/manage/queryOrder.htm">我的订单</a
              >填写开票信息）</span
            >
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { queryOrderDetail, queryPayStatus } from '@/api/order'

export default {
  name: 'PaySuccess',
  data() {
    return {
      memCoupon: null,
      bfeViewOrderInfoExt: {},
      bksServiceMainInfoExt: {},
      order: {},
      invoice: {},
      payStatus: false,
    }
  },
  computed: {
    orderID() {
      return this.$route.query.orderId
    },
  },
  beforeMount() {
    this.getDataDetail()
    this.getPayStatus()
  },
  methods: {
    getPayStatus() {
      return queryPayStatus(this.orderID).then((v) => {
        console.log(v)
        this.payStatus = v.data
      })
    },
    getDataDetail() {
      return queryOrderDetail(this.orderID).then((v) => {
        this.bfeViewOrderInfoExt = v.data
        this.bksServiceMainInfoExt = v.data
        this.order = v.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #f5f5f5;
  height: 500px;
}
.paymentSuccess {
  background-color: #fff;
  width: 1200px;
  height: 480px;
  margin: 0 auto;
  transform: translateY(10px);
  padding: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .left {
    width: 400px;
    .c1 {
      display: block;
      text-align: center;
      font-size: 50px;
      color: #7abd54;
      width: 300px;
      margin: 0px auto 0 auto;
      height: 70px;
    }
    .c2 {
      display: block;
      text-align: center;
      margin: 20px 0px 50px 0px;
      color: #f52f3e;
      font-weight: bold;
      font-size: 26px;
    }
    .c3 {
      text-align: center;
      p {
        text-align: left;
        font-size: 13px;
      }
    }
  }
  .line {
    width: 30px;
    .block {
      height: 440px;
      width: 15px;
      border-right: 1px #e6e6e6 dashed;
    }
    .block2 {
      height: 30px;
      width: 30px;
      background-color: #f5f5f5;
      border-radius: 50%;
    }
    .block3 {
      height: 30px;
      width: 30px;
      background-color: #f5f5f5;
      border-radius: 50%;
    }
  }
  .right {
    width: 400px;
    & > div {
      padding-left: 150px;
    }
    .c4 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 0 !important;
      display: block;
      position: relative;
      padding-left: 175px;
      font-size: 14px;
      color: #4c4c4c;
      line-height: 22px;
      padding-bottom: 15px;
    }
    em {
      font-style: normal;
      position: absolute;
      left: 0px;
      color: #999;
    }
  }
}
</style>
